import { render, staticRenderFns } from "./listOfReinspection.vue?vue&type=template&id=2de1b9b6&scoped=true&"
import script from "./listOfReinspection.vue?vue&type=script&lang=js&"
export * from "./listOfReinspection.vue?vue&type=script&lang=js&"
import style0 from "./listOfReinspection.vue?vue&type=style&index=0&id=2de1b9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1b9b6",
  null
  
)

export default component.exports